import styled from 'styled-components';
import { Button, TextInput } from 'bench-internal-theme';
import Heading from 'primitive-components/Heading';

export const ModalContainer = styled.div`
  width: 769px;
`;

export const CustomHeader = styled.div`
  height: 52px;
  padding-left: 15px;
  padding-top: 10px;
  background: #06a195;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  color: #fff;
`;

export const InputWrapper = styled.div`
  padding: 15px;
`;

export const StyledHeading = styled(Heading)`
  white-space: pre-line;
`;

export const StyledCloseButton = styled(Button)`
  position: absolute;
  top: 10px;
  right: 14px;
  height: 32px;
  padding: 0;
  background-color: #06a195;
  border: none;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const SaveButton = styled(Button)`
  width: 100px;
  height: 44px;
  background: #00877e;
  border-radius: 8px;
  margin-left: auto;
  margin-bottom: 15px;
  margin-right: 15px;
`;

export const ContractorInput = styled.input`
  height: 48px;
  width: 720px;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid #b8b7b5;
  background: #f7f8fa;
  font-size: 14px;
`;
